import { EN } from './en';
import { KR } from './kr';
import { VI } from './vi';

export const STRINGS: any = {
  en: EN,
  kr: KR,
  vi: VI,
};
